import { OpenFile, Viewer, Worker } from "@react-pdf-viewer/core";
import { SelectionMode } from "@react-pdf-viewer/selection-mode";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";

import { useAppDispatch, useAppSelector } from "@/Hook/hooks";
import {
  getReportConfig, loadReport, saveScheduler, Scheduler, setFieldFilter, setReportModelValue, toggleCriteria
} from "@/Redux/Ducks/reportExplorerSlice";
import { ToolbarSlot } from "@react-pdf-viewer/default-layout";
import BaseMethods from "AlignBaseUI/BaseMethods";
import { Accordion, AlignInput, ControlTranslation, Icon, Modal, Workspace } from "AlignComponents";
import { useEffect, useRef, useState } from "react";
// import { requestGetReport } from '@/Redux/Sagas/Requests/reportExplorer';
import { EHelpOpenIn } from "@/Redux/Ducks/helpSlice";
import { setUserFavorite } from "@/Redux/Ducks/homeSlice";
import { setGlobalMessage } from "@/Redux/Ducks/messageSlice";
import { closeTab } from "@/Redux/Ducks/tabSlice";
import { ICriteriaFieldConfig } from "@/UI/Interfaces/IFieldConfig";
import { filterOption } from "@/Utils/constants";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";
import classNames from "classnames";
import { Button, ButtonGroup, Col, Dropdown, DropdownButton, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { MdDownloading, MdImportExport, MdOutlineSchedule } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { Editor } from "react-draft-wysiwyg";
// @ts-ignore
import { ReactMultiEmailInput } from 'react-multi-email-input';
import 'react-multi-email-input/dist/style.css';
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import template from './template';

const ReportExplorer = (props: any) => {
  const dispatch = useAppDispatch();
  let history = useHistory();

  let { routeTo, modalReport } = props;
  if (!routeTo)
    routeTo = props.match.params.routeTo;

  const reportObject = useAppSelector((state) => state.ReportExplorer.reportDetailObject[routeTo]);
  const userEmail = useAppSelector(x => x.User.user.email) || '';
  const userName = useAppSelector(x => x.User.user.username) || '';

  const loadMenuRef = useRef<any>();

  const [loadReportExplorerForce, setLoadReportExplorerForce] = useState<boolean>(false);
  const [schedulerOpen, openScheduler] = useState<boolean>(false);
  const [schedulerModel, setModel] = useState<Scheduler>({
    reportNo: "",
    schedulerName: "",
    frequency: "Daily",
    time: "00:00 ",
    subject: "",
    toEmail: "",
    ccEmails: [],
    emailBody: "",
    format: "PDF"
  });

  const fromEmail: string = "notification@alignbsystems.com"
  const settingSaveTimeout = useRef<any>(null);

  useEffect(() => {
    if (!reportObject)
      dispatch(getReportConfig({ reportObjectno: routeTo }));
  }, []);

  useEffect(() => {
    if (reportObject) {
      const reportNo = reportObject.objectConfiguration.reportobjectno;
      const reportName = reportObject.objectConfiguration.processcodestxt;
      const schedulerName = `${reportObject.objectConfiguration.processcodestxt} Scheduler`;
      const subjectString = `Report: ${reportName}`;
      const contentState: any = ContentState.createFromText(`This Report: ${reportName} was shared to you using the PeopleNest Application. You can review it in the PeopleNest Application.`);
      const editorState: any = EditorState.createWithContent(contentState);

      setModel({
        ...schedulerModel,
        reportNo: reportNo,
        schedulerName: schedulerName,
        subject: subjectString,
        emailBody: editorState
      });
    }
  }, [reportObject])

  useEffect(() => {

    if (settingSaveTimeout.current)
      clearTimeout(settingSaveTimeout.current);
    if (loadReportExplorerForce)
      setLoadReportExplorerForce(false);
    setTimeout(() => {
      setLoadReportExplorerForce(true);
    }, 160);

  }, [history.location.pathname]);

  useEffect(() => {
    setModel({
      ...schedulerModel,
      toEmail: userEmail
    })
  }, [userEmail]);

  const toolbarPluginInstance = toolbarPlugin({
    getFilePlugin: {
      fileNameGenerator: (file: OpenFile) => {

        let fileName = reportObject.objectConfiguration.processcodestxt;

        const transactionfieldObject = reportObject.criteria.find(x => x.transactionfield);
        if (transactionfieldObject) {
          if (!reportObject.previousLoadedCriteriaValue[transactionfieldObject.fieldid].toValue) {
            const transactionno = reportObject.previousLoadedCriteriaValue[transactionfieldObject.fieldid].fromValue;
            if (transactionno && !transactionno.includes(","))
              fileName += `-${transactionno}`;
          }
        }

        return `${fileName}`;
      },
    },
    selectionModePlugin: {
      selectionMode: SelectionMode.Text,
    },
  });

  const { Toolbar } = toolbarPluginInstance;

  const base64toBlob = (data: string) => {
    // Cut the prefix `data:application/pdf;base64` from the raw base 64
    const base64WithoutPrefix = data;

    const bytes = atob(base64WithoutPrefix);
    let length = bytes.length;
    let out = new Uint8Array(length);

    while (length--) {
      out[length] = bytes.charCodeAt(length);
    }

    return new Blob([out], { type: "application/pdf" });
  };

  const BaseFieldStateSet = (fieldId: string, newValue: any, helpSelected: boolean = false, toValue: boolean = false) => {
    dispatch(setReportModelValue({ fieldId, newValue, toValue }));
  };

  const BaseSetFieldFilter = (fieldId: string, filterType: string, caseSensitive: boolean) => {
    dispatch(setFieldFilter({ fieldId, filterType, caseSensitive }));
    document.querySelectorAll(`.filter-container .dropdown-menu`).forEach((x) => x.classList.remove("show"))
  };

  const loadReportFunc = (requiredLetterHead: boolean, exportExcel: boolean) => {

    reportObject.criteria.map(x => {
      if (x.validatemandatory) {
        if (!reportObject.modelValue[x.fieldid].fromValue) {
          dispatch(setGlobalMessage({ error: new Error(`Please fill Mandatory field ${x.fieldlabel}`) }));
          throw null;
        }
      }
    });

    dispatch(loadReport({ reportObjectno: reportObject.objectConfiguration.reportobjectno, requiredLetterHead, exportExcel }));

    if (!exportExcel) {
      if (reportObject.isCriteriaOpen)
        dispatch(toggleCriteria({ reportObjectno: routeTo }));
    }

  };

  const closeReportExplorer = () => {
    dispatch(closeTab(routeTo));
  }

  const criteriaField = (field: ICriteriaFieldConfig, index: number) => {
    const fieldModel = reportObject.modelValue[field.fieldid];
    return (
      <div className="col-4 d-flex align-items-end" key={index}>
        <AlignInput
          key={`from-${field.fieldid}`}
          fieldId={field.fieldid}
          config={{ FieldConfig: [field], BaseFieldStateSet }}
          customFieldValue={fieldModel.fromValue || null}
          customFieldVisible={true}
          customFieldEnable={true}
          customFieldHelpObject={field.helpobjectno || ""}
          customFieldHelpWhere={field.helpwhere || ""}
          customValidateMandatory={field.validatemandatory}
          customHyperLinkJump={field.hyperlinkjump || ""}
          custom={true}
          uniqueKey="from"
          customHelpParams={{
            helpOpenIn: EHelpOpenIn.ReportExplorer,
            multiSelect: field.multiplevalue
          }}
          col="none"
        />
        {
          field.filteroption ?
            <div className="filter-container">
              <DropdownButton
                className="ms-1"
                variant="filter"
                as={ButtonGroup}
                title={<Icon icon="Filter" size="14" color="#575757" className="mx-1" />}
                onClick={() => {
                  document.querySelectorAll(`.filter-container .dropdown-menu:not(#filter-option-${field.fieldid})`).forEach((x) => x.classList.remove("show"))
                  document.getElementById(`filter-option-${field.fieldid}`)?.classList.toggle("show")
                }}>
                {
                  filterOption.filter(x => !x.filterSymbol.isEqual("cs") && x.fieldType.includes(BaseMethods.getControlType(field.controltypeno))).map((x, i) => (
                    <Dropdown.Item
                      key={x.filterSymbol}
                      className={classNames({ active: x.filterSymbol == fieldModel.filterType })}
                      role="button"
                      onClick={() => BaseSetFieldFilter(field.fieldid, x.filterSymbol, fieldModel.caseSensitive)}
                    >
                      {x.filterText}
                    </Dropdown.Item>
                  ))
                }
                <Dropdown.Divider />
                {
                  filterOption.filter(x => x.filterSymbol.isEqual("cs") && x.fieldType.includes(BaseMethods.getControlType(field.controltypeno))).map((x, i) => (
                    <Dropdown.Item
                      key={x.filterSymbol}
                      className={classNames({ active: fieldModel.caseSensitive })}
                      role="button"
                      onClick={() => BaseSetFieldFilter(field.fieldid, fieldModel.filterType, !fieldModel.caseSensitive)}
                    >
                      {x.filterText}
                    </Dropdown.Item>
                  ))
                }
              </DropdownButton>
            </div>
            : null
        }

        <span className="to-value">
          {
            fieldModel.filterType.isEqual("not between", "between") ?
              <AlignInput
                key={`to-${field.fieldid}`}
                fieldId={field.fieldid}
                config={{ FieldConfig: [field], BaseFieldStateSet: (fieldId: string, newValue: any, helpSelected: boolean) => BaseFieldStateSet(fieldId, newValue, helpSelected, true) }}
                customFieldValue={fieldModel.toValue || null}
                customFieldVisible={true}
                customFieldEnable={true}
                customFieldHelpObject={field.helpobjectno || ""}
                customFieldHelpWhere={field.helpwhere || ""}
                customValidateMandatory={field.validatemandatory}
                customHyperLinkJump={field.hyperlinkjump || ""}
                custom={true}
                uniqueKey="to"
                customHelpParams={{
                  helpOpenIn: EHelpOpenIn.ReportExplorer
                }}
              />
              : null
          }
        </span>
      </div>
    );
  }

  const toggleCriteriaFunc = () => {
    dispatch(toggleCriteria({ reportObjectno: routeTo }));
  }

  // favorite
  const BaseSetUserFavorite = (objectcontrollerno: string, objectcontrollerstxt: string, applicationobjecttype: string) => {
    dispatch(setUserFavorite({ objectcontrollerno, objectcontrollerstxt, applicationobjecttype }))
  }

  const openSchedulerFunc = () => {
    openScheduler(true);
  }

  const closeSchedulerFunc = () => {
    openScheduler(false);
  }

  const generateMessage = () => {
    var inboxMessage = draftToHtml(convertToRaw(schedulerModel.emailBody.getCurrentContent()));
    var process = reportObject.objectConfiguration.processcodestxt;
    inboxMessage = template.replaceAll("{{process}}", process)
      .replaceAll("{{from_user}}", userName)
      .replaceAll("{{message}}", inboxMessage);

    return inboxMessage;
  }

  const schedulerReportFunc = () => {
    try {
      var inboxMessage = generateMessage();

      // if (!schedulerModel.schedulerName) {
      //   dispatch(setTabMessage({ message: "Scheduler Name is not available", messageType: EMessageType.Error }));
      //   return;
      // }

      dispatch(saveScheduler({
        ...schedulerModel,
        emailBody: inboxMessage
      }));
      closeSchedulerFunc();
    }
    catch (ex) {
      console.error(ex);
    }
  }

  const onChange = (fieldId: string, value: any) => {
    setModel({
      ...schedulerModel,
      [fieldId]: value
    })
  }

  if (reportObject && loadReportExplorerForce)
    return (
      <div className={classNames(["report-detail", { "modalReport": modalReport }])}>
        <Modal
          modalSize='lg'
          heading="Schedule Report"
          show={schedulerOpen}
          close={closeSchedulerFunc}
          footer={
            <>
              <Button variant="primary" onClick={schedulerReportFunc}>
                <MdOutlineSchedule className="me-2" size="12" />
                Schedule
              </Button>
            </>
          }
        >
          <Form as={Row}>
            <Col md="12">
              <Form.Group className="mb-3" controlId="schedulerName" as={Row}>
                <Form.Label column md="2">Name</Form.Label>
                <Col md="10">
                  <Form.Control type="text" value={schedulerModel.schedulerName} onChange={(e: any) => onChange("schedulerName", e.target.value)} />
                </Col>
              </Form.Group>
            </Col>
            <Col md="12">
              <Form.Group className="mb-3" controlId="format" as={Row}>
                <Form.Label column md="2">Format</Form.Label>
                <Col md="10">
                  <Form.Select value={schedulerModel.format} onChange={(e: any) => onChange("format", e.target.value)}>
                    <option value="PDF">PDF</option>
                    <option value="Excel">Excel</option>
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>
            <Col md="12">
              <Form.Group className="mb-3" controlId="frequency" as={Row}>
                <Form.Label column md="2">Frequency</Form.Label>
                <Col md="10">
                  <Form.Select value={schedulerModel.frequency} onChange={(e: any) => onChange("frequency", e.target.value)}>
                    <option value="D">Daily</option>
                    <option value="W">Weekly</option>
                    <option value="M">Monthly</option>
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>
            <Col md="12">
              <Form.Group className="mb-3" controlId="time" as={Row}>
                <Form.Label column md="2">Time</Form.Label>
                <Col md="10">
                  <TimePicker onChange={(e: any) => onChange("time", e)} value={schedulerModel.time} className="form-control" />
                </Col>
              </Form.Group>
            </Col>
            <Col md="12">
              <Form.Group className="mb-3" controlId="fromMail" as={Row}>
                <Form.Label column md="2">From</Form.Label>
                <Col md="10">
                  <Form.Control type="email" value={fromEmail} readOnly />
                </Col>
              </Form.Group>
            </Col>
            <Col md="12">
              <Form.Group className="mb-3" controlId="toEmail" as={Row}>
                <Form.Label column md="2">To</Form.Label>
                <Col md="10">
                  <Form.Control type="email" value={schedulerModel.toEmail} onChange={(e: any) => onChange("toEmail", e.target.value)} placeholder="To" />
                </Col>
              </Form.Group>
            </Col>
            <Col md="12">
              <Form.Group className="mb-3" controlId="ccEmails" as={Row}>
                <Form.Label column md="2">CC</Form.Label>
                <Col md="10">
                  <ReactMultiEmailInput emails={schedulerModel.ccEmails} setEmails={(e: Array<string>) => onChange("ccEmails", e)} placeholder="CC" />
                </Col>
              </Form.Group>
            </Col>
            <Col md="12">
              <Form.Group className="mb-3" controlId="subject" as={Row}>
                <Form.Label column md="2">Subject</Form.Label>
                <Col md="10">
                  <Form.Control type="text" value={schedulerModel.subject} onChange={(e: any) => onChange("subject", e.target.value)} placeholder="Subject" />
                </Col>
              </Form.Group>
            </Col>
            <Col md="12">
              <Form.Group className="mb-3" controlId="emailBody" as={Row}>
                <Form.Label column md="2">Email Body</Form.Label>
                <Col md="10">
                  {/* <Form.Control as="textarea" rows={3} value={emailMessage} onChange={(e: any) => { setEmailMessage(e.target.value) }} placeholder="Subject" /> */}
                  <Editor
                    wrapperClassName='editor'
                    editorState={schedulerModel.emailBody}
                    onEditorStateChange={(e: any) => onChange("emailBody", e)}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Form>
        </Modal>

        {
          !modalReport ?
            <>
              <div className="screen-action-panel" style={{ backgroundColor: "#f6f6f6" }}>
                <div className="screen-title">
                  {reportObject.objectConfiguration.processcodestxt}

                  <OverlayTrigger placement="bottom" overlay={<Tooltip><ControlTranslation system={true} controlId="lbladdtofavorite" /></Tooltip>}>
                    <div className="favorite" onClick={() => BaseSetUserFavorite(reportObject.objectConfiguration.processcode, reportObject.objectConfiguration.processcodestxt, reportObject.objectConfiguration.applicationobjecttype)}>
                      {
                        reportObject.objectConfiguration.isfavorite ? (
                          <AiFillStar size="24" />
                        ) : (
                          <AiOutlineStar size="24" />
                        )
                      }
                    </div>
                  </OverlayTrigger>
                </div>

                <div className="ms-auto"></div>
                <Workspace objectType="R" />

                {/* <Button variant="light" onClick={openSchedulerFunc}>
                  <MdOutlineSchedule className="me-2" size="16" />
                  Schedule Report
                </Button> */}

                <Button variant="light" onClick={() => { loadReportFunc(false, true) }} className="me-2">
                  <MdImportExport className="me-2" size="16" />
                  Export Excel
                </Button>
              </div>
              <Accordion controlId="lblcriteria" system={true} customManageState={true} customActive={reportObject.isCriteriaOpen} toggleAccordion={(controlId, active) => toggleCriteriaFunc()}>
                <div className="row">

                  <div className="criteria-fields">
                    <div className="container-fluid">
                      <div className="row">
                        {
                          reportObject.criteria.map((x, i) => (
                            criteriaField(x, i)
                          ))
                        }
                      </div>
                      {
                        reportObject.FICriteria.length ?
                          <>
                            <span className="group-label">Financial Dimensions</span>
                            <div className="row">
                              {
                                reportObject.FICriteria.map((x, i) => (
                                  criteriaField(x, i)
                                ))
                              }
                            </div>
                          </>
                          : null
                      }
                    </div>
                  </div>
                </div>
              </Accordion>
            </>
            :
            <>
              <div style={{ marginBottom: 10, display: "flex" }}>
                <span className="criteria-fields">
                  {
                    reportObject.criteria.filter(x => x.showinshortreport).map((x, i) => (
                      criteriaField(x, i)
                    ))
                  }
                </span>
                <Button variant="primary" className="ms-auto" onClick={() => { loadReportFunc(false, false) }}>
                  <MdDownloading className="me-2" size="16" />
                  Load
                </Button>
              </div>
            </>
        }

        {reportObject.report && (
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.9.359/build/pdf.worker.min.js">
            <div className="rpv-core__viewer report-viewer-container">
              <div className="report-viewer-toolbar" style={{}}>
                <Toolbar>
                  {(props: ToolbarSlot) => {
                    const {
                      CurrentPageInput,
                      Download,
                      EnterFullScreen,
                      GoToNextPage,
                      GoToPreviousPage,
                      NumberOfPages,
                      Print,
                      ZoomIn,
                      ZoomOut,
                      ShowSearchPopover,
                    } = props;
                    return (
                      <>
                        <div style={{ padding: "0px 2px" }}>
                          <ShowSearchPopover />
                        </div>
                        <div style={{ padding: "0px 2px" }}>
                          <ZoomOut />
                        </div>
                        <div style={{ padding: "0px 2px" }}>
                          <ZoomIn />
                        </div>
                        <div style={{ padding: "0px 2px", marginLeft: "auto" }}>
                          <GoToPreviousPage />
                        </div>
                        <div style={{ padding: "0px 2px", width: "4rem" }}>
                          <CurrentPageInput />
                        </div>
                        <div style={{ padding: "0px 2px" }}>
                          / <NumberOfPages />
                        </div>
                        <div style={{ padding: "0px 2px" }}>
                          <GoToNextPage />
                        </div>
                        <div style={{ padding: "0px 2px", marginLeft: "auto" }}>
                          <EnterFullScreen />
                        </div>
                        <div style={{ padding: "0px 2px" }}>
                          <Download />
                        </div>
                        <div style={{ padding: "0px 2px" }}>
                          <Print />
                        </div>
                      </>
                    );
                  }}
                </Toolbar>
              </div>
              <div className="report-viewer">
                <Viewer
                  fileUrl={"data:application/pdf;base64," + reportObject.report}
                  plugins={[toolbarPluginInstance]}
                />
              </div>
            </div>
          </Worker>
        )}

        {
          !modalReport ?
            <div className="screen-bottom-panel">
              <Button variant="primary" onClick={() => loadReportFunc(false, false)}>
                Load
              </Button>
              {
                reportObject.requiredLetterHead ?
                  <Button variant="outline-primary" onClick={() => { loadReportFunc(true, false) }} className="me-2">
                    Load Letterhead
                  </Button>
                  : null
              }
              <Button variant="light" onClick={closeReportExplorer}>
                <ControlTranslation system={true} controlId="btncancel" />
              </Button>
            </div>
            : null
        }
      </div>
    );
  else return null;
};

export default ReportExplorer;
